import { createContext } from "react";
const SubCategoryMasterContext = createContext();
export default SubCategoryMasterContext;

